module.exports = __webpack_public_path__ + "static/city-reflections-evening-697c25e0fe90ca69e9ced0612e9cbf53.jpg";